import React, { useState, Fragment } from "react";
import Notification from "../../Notification";
import "./styles.css";
import SingleImageView from "./SingleImageView";
import useConfigs from "../../../hooks/use-config";
import { getFileExt } from "../../../utils/common-utils";

const FileUpload = (props) => {
  let { supportedFileTypes } = useConfigs(["supportedFileTypes"]);

  const {
    onFileSelectSuccess,
    content,
    maxSizeContent,
    imageApiUrl,
    imageViewClass,
    placeholderImgClass,
    dimensionHeight,
    dimensionWidth,
    multiple,
    PlaceholderView,
    onRemove,
    canUploadPDF,
  } = props;

  const fileValue = imageApiUrl || "";
  const [message, setMessage] = useState("");

  if (!canUploadPDF) {
    supportedFileTypes = supportedFileTypes.filter(
      (item) => item.toLowerCase() !== "pdf"
    );
  }

  const acceptedFiles = supportedFileTypes.map((item) => getFileExt[item]);

  const imageViewProps = {
    fileValue,
    maxSizeContent,
    onFileSelectSuccess,
    dimensions: { dimensionWidth, dimensionHeight },
    setMessage: (imageMessage) => setMessage(imageMessage),
    acceptedFiles,
    PlaceholderView,
    onRemove,
  };

  return (
    <Fragment>
      <div className="file-upload">
        <div className="file-container">
          {!multiple && (
            <SingleImageView
              {...imageViewProps}
              content={content}
              imageViewClass={imageViewClass}
              placeholderImgClass={placeholderImgClass}
            />
          )}

          {message && <Notification type="danger" message={message} />}
        </div>
      </div>
    </Fragment>
  );
};

export default FileUpload;
